import React from 'react';
import { connect } from 'react-redux';
import { Button, Accordion } from 'react-bootstrap';
import moment from 'moment';
import Draggable from 'react-draggable';
import _ from 'lodash';

import textUtil from '../../util/text';
import { trackChartPointDetailsView } from '../../util/mixpanel';
import { isWhite } from '../../util/colors';

class CTHDetailsAccordion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      data: {}
    };

    this.handleClose = this.handleClose.bind(this);
  }

  static defaultProps = {
    cycleTimeLabel: 'Cycle time',
    valueLabel: 'Frequency'
  };

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data) {
      this.setState({
        show: true,
        data: this.props.data
      });
    }
  }

  handleClose() {
    this.setState({
      show: false,
      data: {}
    });

    trackChartPointDetailsView('cth', false);
  }

  renderDetail(d, y, bl) {
    const ct = moment.duration(d.cycleTime, 'minutes').format(this.props.timePrecision, { trim: 'mid both' });
    const blockedList = _.find(bl, { listId: d.listId });

    return (
      <p key={y}>
        {d.list}: {ct}{' '}
        {!!blockedList && (
          <span>
            {' '}
            {d.list} blocked time:{' '}
            {moment.duration(blockedList.blockedTime, 'minutes').format(this.props.timePrecision, { trim: 'mid both' })}{' '}
          </span>
        )}{' '}
      </p>
    );
  }

  render() {
    const { show, data } = this.state;
    const { frequency, duration, points } = data;

    return (
      <Draggable defaultPosition={{ x: 95, y: 85 }} axis="both" bounds="parent">
        {!show || !points ? (
          <div></div>
        ) : (
          <div id={this.props.id} className="box_white_shadow detailed_accordion">
            <Button className="btn-close" onClick={this.handleClose}>
              &times;
            </Button>
            <p>
              {this.props.cycleTimeLabel}: {duration}
            </p>
            <p>
              {this.props.valueLabel}: {frequency}
            </p>
            <Accordion>
              {points.map((point, i) => {
                return (
                  <Accordion.Item eventKey={i} key={i} activeKey={i === 0}>
                    <Accordion.Header>
                        <span className={`label_dot ${isWhite(point.color) ? 'label_dot--white' : ''}`} style={{ background: point.color }}></span>
                        {point.card.name}
                    </Accordion.Header>
                    <Accordion.Body>
                      {!!point.card.secondaryName && <p>Summary: {point.card.secondaryName}</p>}
                      {!!point.card.coloredField && (
                        <p>
                          {textUtil.format(point.card.coloredField, null, false, false, 'capitalize')}:{' '}
                          {point.card.coloredValue}
                        </p>
                      )}
                      {!!point.card.url && (
                        <p>
                          <a href={point.card.url} target="_blank">
                            Open in {this.props.app !== 'file' ? this.props.appName : 'new tab'}
                          </a>
                        </p>
                      )}
                      <p>
                        Cycle time:{' '}
                        {moment
                          .duration(_.sumBy(point.details, 'cycleTime'), 'minutes')
                          .format(this.props.timePrecision, {
                            trim: 'mid both'
                          })}
                      </p>
                      {!!point.card.blockedTime && (
                        <p style={{ color: '#ec2132' }}>
                          Blocked time:{' '}
                          {moment.duration(point.card.blockedTime, 'minutes').format(this.props.timePrecision, {
                            trim: 'mid both'
                          })}
                        </p>
                      )}
                      {point.details.map((d, y) => {
                        return this.renderDetail(d, y, point.card.blockedLists);
                      })}
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Accordion>
          </div>
        )}
      </Draggable>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app.app,
    appName: state.app.appName,
    timePrecision: state.filters.timePrecision
  };
};

export default connect(mapStateToProps)(CTHDetailsAccordion);
